import Vue from 'vue'
import Router from 'vue-router'
import HelloWorld from '@/components/HelloWorld'

Vue.use(Router)

export default new Router({
    mode: 'history',
    routes: [
        {
            path: '/',
            name: 'HelloWorld',
            component: HelloWorld
        },
        //骑手资料
        {
            path: '/RiderInformation/myList',
            name: 'myList',
            meta: {
                title: '我的资料'
            },
            component: resolve => require.ensure([], () => resolve(require('@/components/RiderInformation/myList')), 'RiderInformation')
        },
        //我的统计
        {
            path: '/MyStatistics/MyStatistics',
            name: 'MyStatistics',
            meta: {
                title: '我的统计',
                keepAlive: true
            },
            component: resolve => require.ensure([], () => resolve(require('@/components/MyStatistics/MyStatistics')), 'MyStatistics')
        },
        //我的统计 -> 日订单
        {
            path: '/MyStatistics/DailyStatistical',
            name: 'DailyStatistical',
            meta: {
                title: '日订单'
            },
            component: resolve => require.ensure([], () => resolve(require('@/components/MyStatistics/DailyStatistical')), 'MyStatistics')
        },
        //我的统计 -> 日订单 ->无效订单
        {
            path: '/MyStatistics/DayWuXiaoDan',
            name: 'DayWuXiaoDan',
            meta: {
                title: '今日无效订单'
            },
            component: resolve => require.ensure([], () => resolve(require('@/components/MyStatistics/DayWuXiaoDan')), 'MyStatistics')
        },
        //我的统计 -> 月订单
        {
            path: '/MyStatistics/MonthStatistics',
            name: 'MonthStatistics',
            meta: {
                title: '月订单'
            },
            component: resolve => require.ensure([], () => resolve(require('@/components/MyStatistics/MonthStatistics')), 'MyStatistics')
        },
        //我的统计 -> 月订单 ->无效订单
        {
            path: '/MyStatistics/MonthWuXiaoDan',
            name: 'MonthWuXiaoDan',
            meta: {
                title: '本月无效订单'
            },
            component: resolve => require.ensure([], () => resolve(require('@/components/MyStatistics/MonthWuXiaoDan')), 'MyStatistics')
        },
        //我的罚单 ->
        {
            path: '/MyTicket/MyTicket',
            name: 'MyTicket',
            meta: {
                title: '我的罚单'
            },
            component: resolve => require.ensure([], () => resolve(require('@/components/MyTicket/MyTicket')), 'MyTicket')
        },
        //我的罚单 -> 全部订单
        {
            path: '/MyTicket/AllOrder',
            name: 'AllOrder',
            meta: {
                title: '全部订单'
            },
            component: resolve => require.ensure([], () => resolve(require('@/components/MyTicket/AllOrder')), 'MyTicket')
        },
        //我的罚单 -> 可申诉
        {
            path: '/MyTicket/CanAppeal',
            name: 'CanAppeal',
            meta: {
                title: '可申诉'
            },
            component: resolve => require.ensure([], () => resolve(require('@/components/MyTicket/CanAppeal')), 'MyTicket')
        },
        {
            path: "/MerchantProject/TiXian",
            name: "TiXian",
            component: resolve =>
                require.ensure(
                    [],
                    () =>
                        resolve(
                            require("@/components/MerchantProject/TiXian")
                        ),
                    "MerchantProjectFinance"
                )
        },

        {
            path: "/MerchantProject/History",
            name: "History",
            component: resolve =>
                require.ensure(
                    [],
                    () =>
                        resolve(
                            require("@/components/MerchantProject/History")
                        ),
                    "MerchantProjectFinance"
                )
        },

        {
            path: "/MerchantProject/Finance",
            name: "Finance",
            meta: {
                title: "财务管理"
            },
            component: resolve =>
                require.ensure(
                    [],
                    () =>
                        resolve(
                            require("@/components/MerchantProject/Finance")
                        ),
                    "MerchantProjectFinance"
                )
        },
        //我的账本
        {
            path: '/MyBooks/MyBooks',
            name: 'MyBooks',
            meta: {
                title: '我的账本'
            },
            component: resolve => require.ensure([], () => resolve(require('@/components/MyBooks/MyBooks')), 'MyBooks')
        },
        //我的账本->账单列表
        {
            path: '/MyBooks/Bill',
            name: 'Bill',
            meta: {
                title: '账单列表'
            },
            component: resolve => require.ensure([], () => resolve(require('@/components/MyBooks/Bill')), 'MyBooks')
        },
        //我的账本->账单列表->账单详情
        {
            path: '/MyBooks/BillDetails',
            name: 'BillDetails',
            meta: {
                title: '账单详情'
            },
            component: resolve => require.ensure([], () => resolve(require('@/components/MyBooks/BillDetails')), 'MyBooks')
        },
        //我的账本->余额列表
        {
            path: '/MyBooks/BalanceList',
            name: 'BalanceList',
            meta: {
                title: '余额流水'
            },
            component: resolve => require.ensure([], () => resolve(require('@/components/MyBooks/BalanceList')), 'MyBooks')
        },

        //我的账本->余额列表-
        {
            path: '/MyBooks/FlowDetails',
            name: 'FlowDetails',
            meta: {
                title: '流水详情'
            },
            component: resolve => require.ensure([], () => resolve(require('@/components/MyBooks/FlowDetails')), 'MyBooks')
        },
        //我的评价
        {
            path: '/MyComments/MyComments',
            name: 'MyComments',
            meta: {
                title: '我的评价'
            },
            component: resolve => require.ensure([], () => resolve(require('@/components/MyComments/MyComments')), 'MyComments')
        },
        //超级骑手
        {
            path: '/SuperRider/orderList',
            name: 'orderList',
            meta: {
                title: '日订单列表'
            },
            component: resolve => require.ensure([], () => resolve(require('@/components/SuperRider/orderList')), 'SuperRider')
        },
        //订单详情
        {
            path: '/SuperRider/orderDetails',
            name: 'orderDetails',
            meta: {
                title: '订单详情'
            },
            component: resolve => require.ensure([], () => resolve(require('@/components/SuperRider/orderDetails')), 'SuperRider')
        },


        //超级骑手2
        {
            path: '/SuperRider/orderList2',
            name: 'orderList2',
            meta: {
                title: '日订单列表',

            },
            component: resolve => require.ensure([], () => resolve(require('@/components/SuperRider/orderList2')), 'SuperRider')
        },
        {
            path: '/SuperRider/MarketList',
            name: 'MarketList',
            meta: {
                title: '商家列表',

            },
            component: resolve => require.ensure([], () => resolve(require('@/components/SuperRider/Market/MarketList')), 'SuperRider')
        },
        //添加满减补贴活动
        {
            path: '/SuperRider/orderList3',
            name: 'orderList3',
            meta: {
                title: '满减活动列表',
            },
            component: resolve => require.ensure([], () => resolve(require('@/components/SuperRider/orderList3')), 'SuperRider')
        },
        //活动列表
        {
            path: '/SuperRider/ActiveList',
            name: 'ActiveList',
            meta: {
                title: '活动列表',
            },
            component: resolve => require.ensure([], () => resolve(require('@/components/SuperRider/ActiveList/index')), 'SuperRider')
        },
        //活动推送
        {
            path: '/SuperRider/MarketLists',
            name: 'MarketLists',
            meta: {
                title: '活动推送',
            },
            component: resolve => require.ensure([], () => resolve(require('@/components/SuperRider/ActiveList/MarketLists')), 'SuperRider')
        },
        //报名列表
        {
            path: '/SuperRider/EnrollmentList',
            name: 'EnrollmentList',
            meta: {
                title: '报名列表',
            },
            component: resolve => require.ensure([], () => resolve(require('@/components/SuperRider/ActiveList/EnrollmentList')), 'SuperRider')
        },
        //收费点
        {
            path: '/SuperRider/orderList7',
            name: 'orderList7',
            meta: {
                title: '收费点',
            },
            component: resolve => require.ensure([], () => resolve(require('@/components/SuperRider/orderList7')), 'SuperRider')
        },
        //商家入驻
        {
            path: '/SuperRider/MarketRegistration',
            name: 'MarketRegistration',
            meta: {
                title: '商家入驻',
            },
            component: resolve => require.ensure([], () => resolve(require('@/components/SuperRider/MarketRegistration/index')), 'SuperRider')
        },
        //快递站点入驻
        {
            path: '/SuperRider/siteEntry',
            name: 'siteEntry',
            meta: {
                title: '快递站点入驻',
            },
            component: resolve => require.ensure([], () => resolve(require('@/components/SuperRider/siteEntry/siteEntry')), 'SuperRider')
        },
        //快递站点入驻-编辑新增
        {
            path: '/SuperRider/siteEntry/edit',
            name: 'siteEntryEdit',
            meta: {
                title: '快递站点入驻',
            },
            component: resolve => require.ensure([], () => resolve(require('@/components/SuperRider/siteEntry/siteEntryEdit')), 'SuperRider')
        },
        //快递站点入驻-编辑新增
        {
            path: '/SuperRider/siteEntry/map',
            name: 'siteEntryMap',
            meta: {
                title: '地址选区',
            },
            component: resolve => require.ensure([], () => resolve(require('@/components/SuperRider/siteEntry/siteEntryMap')), 'SuperRider')
        },
        //商家审核页面
        {
            path: '/SuperRider/MarketRegistrationProcessing',
            name: 'MarketRegistrationProcessing',
            meta: {
                title: '商家审核页面',
            },
            component: resolve => require.ensure([], () => resolve(require('@/components/SuperRider/MarketRegistration/MarketRegistrationProcessing')), 'SuperRider')
        },
        //商家转化配送方式审核
        {
            path: '/SuperRider/orderList10',
            name: 'orderList10',
            meta: {
                title: '商家转化配送方式审核',
            },
            component: resolve => require.ensure([], () => resolve(require('@/components/SuperRider/orderList10')), 'SuperRider')
        },
        //商家转化配送方式审核
        {
            path: '/SuperRider/orderList11',
            name: 'orderList11',
            meta: {
                title: '商家转化配送方式审核',
            },
            component: resolve => require.ensure([], () => resolve(require('@/components/SuperRider/orderList11')), 'SuperRider')
        },
        //意见反馈
        {
            path: '/SuperRider/Feedback',
            name: 'Feedback',
            meta: {
                title: '意见反馈',
            },
            component: resolve => require.ensure([], () => resolve(require('@/components/SuperRider/Feedback/Feedback')), 'SuperRider')
        },
        //超级骑手推送
        {
            path: '/SuperRider/Pushnotification',
            name: 'Pushnotification',
            meta: {
                title: '超级骑手推送',
            },
            component: resolve => require.ensure([], () => resolve(require('@/components/SuperRider/Pushnotification')), 'SuperRider')
        },
        //回答页面
        {
            path: '/SuperRider/quession',
            name: 'quession',
            meta: {
                title: '回答',
            },
            component: resolve => require.ensure([], () => resolve(require('@/components/SuperRider/Feedback/quession')), 'SuperRider')
        },
        //驳回原因
        {
            path: '/SuperRider/orderList12',
            name: 'orderList12',
            meta: {
                title: '驳回原因',
            },
            component: resolve => require.ensure([], () => resolve(require('@/components/SuperRider/orderList12')), 'SuperRider')
        },
        //订单详情2
        {
            path: '/SuperRider/orderDetails2',
            name: 'orderDetails2',
            meta: {
                title: '订单详情'
            },
            component: resolve => require.ensure([], () => resolve(require('@/components/SuperRider/orderDetails2')), 'SuperRider')
        },


        //派单页面
        {
            path: '/SuperRider/Send_single',
            name: 'Send_single',
            meta: {
                title: '派单页面'
            },
            component: resolve => require.ensure([], () => resolve(require('@/components/SuperRider/Send_single')), 'SuperRider')
        },
        //地图
        {
            path: '/SuperRider/map',
            name: 'map',
            meta: {
                title: '地图'
            },
            component: resolve => require.ensure([], () => resolve(require('@/components/SuperRider/map')), 'SuperRider')
        },

        //城市开关
        {
            path: '/SuperRider/serverSwitch',
            name: 'serverSwitch',
            meta: {
                title: '城市开关'
            },
            component: resolve => require.ensure([], () => resolve(require('@/components/SuperRider/serverSwitch')), 'SuperRider')
        },
        {
            path: '/SuperRider/WeatherSurchargeDistanceCharge',
            name: 'WeatherSurchargeDistanceCharge',
            meta: {
                title: '雨雪天气附加费'
            },
            component: resolve => require.ensure([], () => resolve(require('@/components/SuperRider/WeatherSurchargeDistanceCharge')), 'SuperRider')
        },
        {
            path: '/SuperRider/freepriceSetting',
            name: 'freepriceSetting',
            meta: {
                title: '配送费设置'
            },
            component: resolve => require.ensure([], () => resolve(require('@/components/SuperRider/freepriceSetting')), 'SuperRider')
        },
        //微信消息推送-绑定（新）
        {
            path: '/WechatMessagePush/MarketLoginBuild',
            name: 'MarketLoginBuild',
            meta: {
                title: '微信绑定'
            },
            component: resolve => require.ensure([], () => resolve(require('@/components/WechatMessagePush/MarketLoginBuild')), 'WechatMessagePush')

        },
        //微信消息
        {
            path: '/WechatMessagePush/Message',
            name: 'Message',
            meta: {
                title: '提示'
            },
            component: resolve => require.ensure([], () => resolve(require('@/components/WechatMessagePush/Message')), 'WechatMessagePush')

        },
        //微信消息推送-绑定
        {
            path: '/WechatMessagePush/Binding',
            name: 'WechatMessagePushBinding',
            meta: {
                title: '微信绑定'
            },
            component: resolve => require.ensure([], () => resolve(require('@/components/WechatMessagePush/Binding')), 'WechatMessagePush')

        },
        //微信消息推送-绑定
        {
            path: '/WechatMessagePush/Unbound',
            name: 'WechatMessagePushUnbound',
            meta: {
                title: '微信解绑'
            },
            component: resolve => require.ensure([], () => resolve(require('@/components/WechatMessagePush/Unbound')), 'WechatMessagePush')
        },
        //骑手管理
        {
            path: '/SuperRider/orderListqsgl',
            name: 'orderListqsgl',
            meta: {
                title: '骑手管理'
            },
            component: resolve => require.ensure([], () => resolve(require('@/components/SuperRider/orderListqsgl')), 'SuperRider')
        },
        //骑手审核
        {
            path: '/SuperRider/shenhe',
            name: 'shenhe',
            meta: {
                title: '骑手审核'
            },
            component: resolve => require.ensure([], () => resolve(require('@/components/SuperRider/shenhe')), 'SuperRider')
        },
        //骑手审核
        {
            path: '/SuperRider/webview',
            name: 'webview',
            meta: {
                title: '叮个饭'
            },
            component: resolve => require.ensure([], () => resolve(require('@/components/SuperRider/webview')), 'SuperRider')
        },
        //微信消息推送-选择类型
        {
            path: '/WechatMessagePush/choose',
            name: 'WechatMessagePushChoose',
            meta: {
                title: '绑定微信推送'
            },
            component: resolve => require.ensure([], () => resolve(require('@/components/WechatMessagePush/choose')), 'WechatMessagePush')

        },
        //微信消息推送-绑定
        {
            path: '/WechatMessagePush/RiderBinding',
            name: 'WechatMessagePushRiderBinding',
            meta: {
                title: '骑手微信绑定'
            },
            component: resolve => require.ensure([], () => resolve(require('@/components/WechatMessagePush/RiderBinding')), 'WechatMessagePush')

        },
        //超级骑手-活动中心
        {
            path: '/ActivityCenter',
            name: 'ActivityCenter',
            meta: {
                title: '任务中心'
            },
            component: resolve => require.ensure([], () => resolve(require('@/components/ActivityCenter')), 'ActivityCenter')
        },

        //骑手app  右上角地图
        {
            path: '/RiderMap/riderMap',
            name: 'riderMap',
            meta: {
                title: '骑手地图'
            },
            component: resolve => require.ensure([], () => resolve(require('@/components/RiderMap/riderMap')), 'RiderMap')

        },

        //骑手app  所有订单状态
        {
            path: '/OrderAllStatus/allStatus',
            name: 'OrderAllStatus',
            meta: {
                title: '任务列表'
            },
            component: resolve => require.ensure([], () => resolve(require('@/components/OrderAllStatus/allStatus')), 'OrderAllStatus')

        },
        //骑手app  订单详情
        {
            path: '/OrderAllStatus/orderDetails',
            name: 'OrderAllStatus',
            meta: {
                title: '订单详情'
            },
            component: resolve => require.ensure([], () => resolve(require('@/components/OrderAllStatus/orderDetails')), 'OrderAllStatus')

        },
        //骑手app  右上角地图
        {
            path: '/RiderMap/riderMap_tuiJianDan',
            name: 'riderMap',
            meta: {
                title: '骑手地图'
            },
            component: resolve => require.ensure([], () => resolve(require('@/components/RiderMap/riderMap_tuiJianDan')), 'RiderMap')

        },
        //转单列表
        {
            path: '/OrderAllStatus/zhuandan_rider',
            name: 'OrderAllStatus',
            meta: {
                title: '选择骑手'
            },
            component: resolve => require.ensure([], () => resolve(require('@/components/OrderAllStatus/zhuandan_rider')), 'OrderAllStatus')

        },
        //骑手订单排行
        {
            path: '/SuperRider/rider_order_ranking',
            name: 'rider_order_ranking',
            meta: {
                title: '骑手订单排行'
            },
            component: resolve => require.ensure([], () => resolve(require('@/components/SuperRider/rider_order_ranking')), 'SuperRider')

        },
        //活动中心-明细
        {
            path: '/ActivityCenter/detail',
            name: 'detail',
            meta: {
                title: '明细'
            },
            component: resolve => require.ensure([], () => resolve(require('@/components/ActivityCenter/Detail.vue')), 'ActivityCenter')

        },
        //活动中心-上传凭证
        {
            path: '/ActivityCenter/upload',
            name: 'upload',
            meta: {
                title: '任务中心'
            },
            component: resolve => require.ensure([], () => resolve(require('@/components/ActivityCenter/upload.vue')), 'ActivityCenter')

        },

        //骑手注册 选择城市
        {
            path: '/Register/SelectCity',
            name: 'SelectCity',
            meta: {
                title: '选择城市'
            },
            component: resolve => require.ensure([], () => resolve(require('@/components/Register/SelectCity.vue')), 'SelectCity')
        },
         //传送订单图片
        {
            path: '/OrderAllStatus/transferPictures',
            name: 'transferPictures',
            meta: {
                title: '上传图片'
            },
            component: resolve => require.ensure([], () => resolve(require('@/components/OrderAllStatus/transferPictures')), 'SuperRider')

        },
        //超级骑手导航页
        {
            path: '/SuperRider/NavigationPage',
            name: 'superRiderPage',
            meta: {
                title: '导航页'
            },
            component: resolve => require.ensure([], () => resolve(require('@/components/SuperRider/NavigationPage')), 'SuperRider')

        },

        //合规管理 -写日报
        {
            path: '/HeguiGuanli/FoodInspectionDayList',
            name: 'FoodInspectionDayList',
            meta: {
                title: '每日食品安全检查记录'
            },
            component: resolve => require.ensure([], () => resolve(require('@/components/HeguiGuanli/FoodInspectionDayList')), 'HeguiGuanli')
        },
        {
            path: '/HeguiGuanli/FoodInspectionDay',
            name: 'FoodInspectionDay',
            meta: {
                title: '每日食品安全检查'
            },
            component: resolve => require.ensure([], () => resolve(require('@/components/HeguiGuanli/FoodInspectionDay')), 'HeguiGuanli')
        },
        {
            path: '/HeguiGuanli/FoodInspectionWeekList',
            name: 'FoodInspectionWeekList',
            meta: {
                title: '每周食品安全检查记录'
            },
            component: resolve => require.ensure([], () => resolve(require('@/components/HeguiGuanli/FoodInspectionWeekList')), 'HeguiGuanli')
        },
        {
            path: '/HeguiGuanli/FoodInspectionMonthList',
            name: 'FoodInspectionMonthList',
            meta: {
                title: '每月食品安全检查记录'
            },
            component: resolve => require.ensure([], () => resolve(require('@/components/HeguiGuanli/FoodInspectionMonthList')), 'HeguiGuanli')
        },
        //合规管理
        {
            path: '/HeguiGuanli/FoodInspectionMonth',
            name: 'FoodInspectionMonth',
            meta: {
                title: '每月食品安全检查'
            },
            component: resolve => require.ensure([], () => resolve(require('@/components/HeguiGuanli/FoodInspectionMonth')), 'HeguiGuanli')
        },
        //合规管理
        {
            path: '/HeguiGuanli/FoodInspectionWeek',
            name: 'FoodInspectionWeek',
            meta: {
                title: '每周食品安全检查'
            },
            component: resolve => require.ensure([], () => resolve(require('@/components/HeguiGuanli/FoodInspectionWeek')), 'HeguiGuanli')
        },
        {
            path: '/HeguiGuanli/FoodSafetyExam',
            name: 'FoodSafetyExam',
            meta: {
                title: '食品安全员考试试卷'
            },
            component: resolve => require.ensure([], () => resolve(require('@/components/HeguiGuanli/FoodSafetyExam')), 'HeguiGuanli')
        },
        {
            path: '/HeguiGuanli/CityFoodSafetyExam',
            name: 'CityFoodSafetyExam',
            meta: {
                title: '镇站点食品安全员考试试卷'
            },
            component: resolve => require.ensure([], () => resolve(require('@/components/HeguiGuanli/CityFoodSafetyExam')), 'HeguiGuanli')
        },
        {
            path: '/Map/CityMap',
            name: 'MapCityMap',
            meta: {
                title: '镇站点食品安全员考试试卷'
            },
            component: resolve => require.ensure([], () => resolve(require('@/components/Map/CityMap')), 'Map')
        }
    ]
})



// WEBPACK FOOTER //
// ./src/router/index.js